import { baseUrl } from "@/config/env";
import request from "@/router/axios";
import { parseParam } from "@/util/util";

export const getDynamicType = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_type?` + params,
    method: "GET",
  });
};
export const addDynamicType = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_type`,
    method: "POST",
    data: params,
  });
};
export const delDynamicType = (deleteOption, ids) => {
  let temp = ids.join(",");
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_type/${temp}?option=${deleteOption}`,
    method: "DELETE",
  });
};
export const editDynamicType = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/dynamic_type`,
    method: "PUT",
    data: params,
  });
};
export const findAllSuperiorDepartment = () => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/department/findAllSuperiorDepartment`,
    method: "GET",
  });
};
export const findProvince = () => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province`,
    method: "GET",
  });
};
export const findCitys = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/citys/${id}`,
    method: "GET",
  });
};
export const findAreas = (id) => {
  return request({
    url: `${baseUrl}/joins-basic/v1/province/areas/${id}`,
    method: "GET",
  });
};
export const findEngineeringProjectDetail = (id) => {
  return request({
    url: `${baseUrl}/joins-work/v2/engineering-project/${id}`,
    method: "GET",
  });
};

export const findTagslList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/label?` + params,
    method: "GET",
  });
};

export const findLabelList = (params) => {
  params = parseParam(params);
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/label/select?` + params,
    method: "GET",
  });
};

export const addTags = (params) => {
  return request({
    url: `${baseUrl}/joins-sales-cloud/v1/label`,
    method: "POST",
    data: params,
  });
};
